import { ButtonGroup } from "@qw/ui";

import { ChatContextUsageIndicator } from "./chat-context-usage-indicator";
import { ChatFormAbortButton } from "./chat-form-abort-button";
import { ChatFormAudioWaveform } from "./chat-form-audio-waveform";
import { ChatFormPlusMenu } from "./chat-form-plus-menu";
import { ChatFormStartRecordingVoiceButton } from "./chat-form-start-recording-voice-button";
import { ChatFormStopRecordingVoiceButton } from "./chat-form-stop-recording-voice-button";
import { ChatFormSubmitButton } from "./chat-form-submit-button";
import { useChatForm } from "./use-chat-form";

export const ChatFormFooter = () => {
  const { isRecording, isProcessing, isStreaming, hasInput, hasFiles } = useChatForm();

  return (
    <ButtonGroup className="p-1.5 gap-1">
      {!isRecording && !isProcessing && <ChatFormPlusMenu />}

      <span className="flex-1" />

      {!isRecording && <ChatContextUsageIndicator />}

      {isRecording && <ChatFormAudioWaveform />}

      {(isRecording || isProcessing) && !isStreaming && <ChatFormStopRecordingVoiceButton />}

      {!isRecording && !isProcessing && !isStreaming && !hasInput && <ChatFormStartRecordingVoiceButton />}

      {!isStreaming && (hasInput || hasFiles || isRecording || isProcessing) && <ChatFormSubmitButton />}

      {isStreaming && <ChatFormAbortButton />}
    </ButtonGroup>
  );
};
